//imports
import {
    ACCOUNTS_CREATE_EDIT_ACCOUNT_OPEN_MODAL,
    ACCOUNTS_CREATE_EDIT_ACCOUNT_CLOSE_MODAL,
    ACCOUNTS_CREATE_ACCOUNT_REQUEST,
    ACCOUNTS_CREATE_ACCOUNT_RESULT,
    ACCOUNTS_EDIT_ACCOUNT_REQUEST,
    ACCOUNTS_EDIT_ACCOUNT_RESULT,
    ACCOUNTS_CREATE_EDIT_ACCOUNT_SEARCH_ROLES_REQUEST,
    ACCOUNTS_CREATE_EDIT_ACCOUNT_SEARCH_ROLES_RESULT,
    ACCOUNTS_CREATE_EDIT_ACCOUNT_GET_ROLE_REQUEST,
    ACCOUNTS_CREATE_EDIT_ACCOUNT_GET_ROLE_RESULT,
    ACCOUNTS_CREATE_EDIT_ACCOUNT_GET_ACCOUNT_REQUEST,
    ACCOUNTS_CREATE_EDIT_ACCOUNT_GET_ACCOUNT_RESULT,
    ACCOUNTS_CREATE_EDIT_ACCOUNT_GET_CUSTOM_ROLE_REQUEST,
    ACCOUNTS_CREATE_EDIT_ACCOUNT_GET_CUSTOM_ROLE_RESULT,
    ACCOUNTS_CREATE_EDIT_ACCOUNT_GET_ROLE_MODULES_TEMPLATE_REQUEST,
    ACCOUNTS_CREATE_EDIT_ACCOUNT_GET_ROLE_MODULES_TEMPLATE_RESULT,
    ACCOUNTS_CREATE_EDIT_ACCOUNT_SEARCH_TIMEZONES_RESULT,
    ACCOUNTS_CREATE_EDIT_ACCOUNT_SEARCH_TIMEZONES_REQUEST,
    ACCOUNTS_CREDENCIAL_VALIDATION_REQUEST,
    ACCOUNTS_CREDENCIAL_VALIDATION_RESULT,
    CLEAR_REDUX,
} from 'Redux/actionTypes';

//initial values
const INIT_STATE = {
    createAccount: null,
    editAccount: null,
    loading: false,
    openModal: false,
    rolesLoading: false,
    roles: [],
    roleLoading: false,
    role: null,
    account: null,
    resultAccount: null,
    resultAccountLoading: false,
    roleModuleLoading: false,
    customRole: null,
    customRoleLoading: false,
    roleModuleTemplate: [],
    roleModuleTemplateLoading: false,
    timeZones: [],
    timeZonesLoading: false,
    credentialValidation: null,
};


//change redux object
export default (state = INIT_STATE, action) => {
    switch (action.type) {

        case ACCOUNTS_CREATE_EDIT_ACCOUNT_GET_ROLE_MODULES_TEMPLATE_REQUEST:
            return { ...state, roleModuleTemplateLoading: true }

        case ACCOUNTS_CREATE_EDIT_ACCOUNT_GET_ROLE_MODULES_TEMPLATE_RESULT:
            return { ...state, roleModuleTemplateLoading: false, roleModuleTemplate: action.payload }

        case ACCOUNTS_CREATE_EDIT_ACCOUNT_OPEN_MODAL:
            return { ...state, openModal: true, account: action.payload }

        case ACCOUNTS_CREATE_EDIT_ACCOUNT_CLOSE_MODAL:
            return { ...state, openModal: false }

        case ACCOUNTS_CREATE_ACCOUNT_REQUEST:
            return { ...state, loading: true }

        case ACCOUNTS_CREATE_ACCOUNT_RESULT:
            return { ...state, loading: false, createAccount: action.payload }

        case ACCOUNTS_EDIT_ACCOUNT_REQUEST:
            return { ...state, loading: true }

        case ACCOUNTS_EDIT_ACCOUNT_RESULT:
            return { ...state, loading: false, editAccount: action.payload }

        case ACCOUNTS_CREATE_EDIT_ACCOUNT_SEARCH_ROLES_REQUEST:
            return { ...state, rolesLoading: true }

        case ACCOUNTS_CREATE_EDIT_ACCOUNT_SEARCH_ROLES_RESULT:
            return { ...state, rolesLoading: false, roles: action.payload }

        case ACCOUNTS_CREATE_EDIT_ACCOUNT_GET_ROLE_REQUEST:
            return { ...state, roleModuleLoading: true }

        case ACCOUNTS_CREATE_EDIT_ACCOUNT_GET_ROLE_RESULT:
            return { ...state, roleModuleLoading: false, role: action.payload }

        case ACCOUNTS_CREATE_EDIT_ACCOUNT_GET_ACCOUNT_REQUEST:
            return { ...state, resultAccountLoading: true }

        case ACCOUNTS_CREATE_EDIT_ACCOUNT_GET_ACCOUNT_RESULT:
            return { ...state, resultAccount: action.payload, resultAccountLoading: false }

        case ACCOUNTS_CREATE_EDIT_ACCOUNT_GET_CUSTOM_ROLE_REQUEST:
            return { ...state, customRoleLoading: true }

        case ACCOUNTS_CREATE_EDIT_ACCOUNT_GET_CUSTOM_ROLE_RESULT:
            return { ...state, customRoleLoading: false, customRole: action.payload }

        case ACCOUNTS_CREATE_EDIT_ACCOUNT_SEARCH_TIMEZONES_REQUEST:
            return { ...state, timeZonesLoading: true }

        case ACCOUNTS_CREATE_EDIT_ACCOUNT_SEARCH_TIMEZONES_RESULT:
            return { ...state, timeZones: action.payload, timeZonesLoading: false }

        case ACCOUNTS_CREDENCIAL_VALIDATION_REQUEST:
            return { ...state, loading: true }

        case ACCOUNTS_CREDENCIAL_VALIDATION_RESULT:
            return { ...state, loading: false, credentialValidation: action.payload }

        case CLEAR_REDUX:
            return ["", "CREATE_EDIT_ACCOUNT"].includes(action.payload.option)
                ? action.payload.parameters
                    ? { ...state, ...action.payload.parameters }
                    : { ...INIT_STATE }
                : { ...state };

        default:
            return state;
    }
};